import {useEffect, useState} from 'react';
import {dataMultiChart} from '../../utils/types/multiChart.types';
import {Grid} from '@mui/material';
import {useStylesBorder} from '../../utils/styles/styles';
import {useEstadisticasCRM} from '../hooks/useEstadisticasCRM';
import { mapperCantAtencionesToDataMultiChar } from '../../utils/mappers/mapperCantAtencionesToDataMultiChar';
import { LineBarDateMultiChar } from '../components/LineBarDateMultiChart';
interface LlavesChartProps {
   fecha: Date;
}

export const AtencionesPorProducto: React.FC<LlavesChartProps> = ({fecha}) => {
   const {classes} = useStylesBorder();
   const [dataMultiChart, setDataMultiChart] = useState<dataMultiChart[]>([]);
   const [dataResumen, setDataResumen] = useState<any[]>([]);
   const {getResumenAtenciones} = useEstadisticasCRM();
   const fetchResumenAtenciones = async () => {
      const result = await getResumenAtenciones({fecha: fecha});
      if (result) {
         setDataResumen(result);
      }
   };
   useEffect(() => {
      fetchResumenAtenciones();
   }, []);
   useEffect(() => {
      if (dataResumen) {
         const newData = mapperCantAtencionesToDataMultiChar({
            data: dataResumen
         });
         setDataMultiChart(newData);
      }
   }, [dataResumen]);
   return (
      <Grid container className={classes.border}>
         <LineBarDateMultiChar
            titleLevel={{
               0: 'Atenciones por Meses',
               1: 'Atenciones por Producto',
               2: 'Atenciones por Asesor',
               3: 'Atenciones por Tipo'
            }}
            codIgnore="otros"
            data={dataMultiChart}
            defaultSlider={{end: fecha.getMonth(), start: 0}}
            maxColumns={{1:10}}
            minLevel={1}
            maxLevel={3}
         />
      </Grid>
   );
};
